import { render } from "./CardTitle.vue?vue&type=template&id=2a49798e&scoped=true"
import script from "./CardTitle.vue?vue&type=script&lang=js"
export * from "./CardTitle.vue?vue&type=script&lang=js"

import "./CardTitle.vue?vue&type=style&index=0&id=2a49798e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a49798e"]])

export default __exports__